import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Box, Button, Card, TextField, Typography } from '@mui/material'
import { SwatchesPicker } from 'react-color'
import axios from 'axios'
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import DeleteIcon from '@mui/icons-material/Delete'
import SellIcon from '@mui/icons-material/Sell'
import { DOMAIN, api } from '../../utils/api'
import { getFromStorage } from '../../utils/storage'
import { handleError } from '../../utils/error'
import UserLayout from '../../layouts/UserLayout'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { currentUserActions, loadingActions } from '../../redux/store'
import { mainGreen, mainRed } from '../../utils/color'

export default function TagByStore() {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const { storeId } = useParams()
	const token = getFromStorage('current-user')?.accessToken
	const [color, setColor] = useState('#000')
	const [reload, setReload] = useState(false)
	const tagRef = useRef()

	const handleChange = (color) => {
		setColor(color.hex)
	}
	const postTag = async function () {
		const name = tagRef.current.value
		if (name.trim() === '') {
			alert('Nội dung tag không được để trống!')
			return
		}
		try {
			const res = await axios({
				url: api.POST_TAG_ADMIN,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data: { name, store: storeId, color },
				method: 'POST',
				withCredentials: true,
			})
			setReload(!reload)
			if (res.data.message) {
				alert(res.data.message)
			}
			tagRef.current.value = ''
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	return (
		<UserLayout>
			<Box sx={{ maxWidth: 992, margin: '0 auto' }}>
				<Box
					sx={{
						marginTop: '10px',
						padding: '20px 0',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						maxWidth: 992,
						marginLeft: 'auto',
						marginRight: 'auto',
					}}>
					<TextField
						inputRef={tagRef}
						sx={{ mb: 2, background: '#fff', minWidth: '300px' }}
						label='Nhập nội dung tag'></TextField>
					<Box
						sx={{
							mb: 2,
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}>
						<Typography
							sx={{
								mb: 1,
								background: `${color}`,
								color: '#fff',
								padding: '5px 10px',
								borderRadius: '10px',
								position: 'relative',
							}}>
							# tag
							<SellIcon
								sx={{
									fontSize: '18px',
									position: 'absolute',
									bottom: '-5px',
									right: '-10px',
									color: mainRed,
								}}
							/>
						</Typography>
						<SwatchesPicker height='150px' onChangeComplete={handleChange} />
					</Box>
					<Button
						size='small'
						variant='contained'
						sx={{
							background: mainGreen,
							'&:hover': { background: mainGreen },
						}}
						onClick={() => {
							postTag()
						}}>
						<AddCircleOutlineOutlinedIcon sx={{ mr: 1 }} /> Thêm tag
					</Button>
				</Box>
				<ListTag token={token} storeId={storeId} reload={reload} />
			</Box>
		</UserLayout>
	)
}

function ListTag(props) {
	const [tags, setTags] = useState([])
	const draggTag = useRef(0)
	const draggOverTag = useRef(0)
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const getTags = useCallback(
		async function () {
			dispatch(loadingActions.isLoading())
			try {
				const response = await axios({
					url: `${DOMAIN}/admin/tags/${props.storeId}`,
					headers: {
						Authorization: `Bearer ${props.token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setTags(response.data)
				dispatch(loadingActions.isLoaded())
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[props.token, props.storeId, dispatch, navigate],
	)
	useEffect(() => {
		getTags()
	}, [getTags, props.reload])
	const deleteTag = async function (tagId) {
		try {
			await axios({
				url: api.DELETE_TAG_ADMIN,
				headers: {
					Authorization: `Bearer ${props.token}`,
				},
				data: { tagId },
				method: 'DELETE',
				withCredentials: true,
			})
			await getTags()
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}
	const updateTag = async function (tags) {
		try {
			await axios({
				url: api.UPDATE_TAG_ADMIN,
				headers: {
					Authorization: `Bearer ${props.token}`,
				},
				data: { tags, storeId: props.storeId },
				method: 'PUT',
				withCredentials: true,
			})
			await getTags()
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	function handleSort() {
		const temp1 = draggTag.current
		const temp2 = draggOverTag.current
		let tagsShift
		if (temp1 > temp2) {
			tagsShift = [...tags.slice(0, temp2), tags[temp1], ...tags.slice(temp2, temp1), ...tags.slice(temp1 + 1)]
		} else {
			tagsShift = [...tags.slice(0, temp1), ...tags.slice(temp1 + 1, temp2 + 1), tags[temp1], ...tags.slice(temp2 + 1)]
		}
		tagsShift.map((e, i) => {
			return (e.index = i)
		})
		updateTag(tagsShift)
		setTags(tagsShift)
	}

	return (
		<>
			{tags?.map((tag, index) => {
				return (
					<Card
						draggable
						onDragStart={() => (draggTag.current = index)}
						onDragEnter={() => (draggOverTag.current = index)}
						onDragEnd={handleSort}
						onDragOver={(e) => e.preventDefault()}
						sx={{
							margin: '5px auto',
							padding: '5px',
							maxWidth: '400px',
							display: 'flex',
							alignItems: 'flex-end',
						}}
						key={index}>
						<Typography
							sx={{
								mb: 1,
								background: `${tag.color}`,
								color: '#fff',
								padding: '5px 10px',
								borderRadius: '10px',
								maxWidth: '300px',
								fontSize: '0.8rem',
							}}>
							{tag.name}
						</Typography>
						<Box sx={{ marginLeft: 'auto' }}>
							<Button
								onClick={() => {
									const confirmDelete = window.confirm('Bạn có chắc muốn xóa tag này?')
									if (confirmDelete) {
										deleteTag(tag._id)
									}
								}}>
								<DeleteIcon sx={{ color: mainRed }} />
							</Button>
						</Box>
					</Card>
				)
			})}
		</>
	)
}
